module.exports = __webpack_public_path__ + "img/test-completed.d21f591e.svg";